import { useWindowDimensions } from "react-native";
import { STAT_ONE_COLUMN_FONT_SCALE, STAT_ONE_COLUMN_WIDTH } from "./progressViewStyles";

// #321: true when a stat box should take the whole row (narrow window or big
// system text), so a long label is not cut mid-word. `enabled` false keeps
// the two-column picture (the report's, the same on every phone).
export function useStatOneColumn(enabled = true): boolean {
  const { width, fontScale } = useWindowDimensions();
  return (
    enabled &&
    (width < STAT_ONE_COLUMN_WIDTH || fontScale >= STAT_ONE_COLUMN_FONT_SCALE)
  );
}
